import React, { useState, useRef, useEffect } from "react";
import { Menu } from "antd";
import { PageConstant } from "../../../constants";
import "./AvatarDropDown.scss";
import useOutsideAlerter from "../../../hooks/useOutSideAlterter";
import useIsMobile from "../../../hooks/useIsMobile";
import { connect } from "react-redux";
import DrawerActions from "../../../actions/Drawer";

const DropDownMenu = ({ onLogout }) => (
  <div className="avatar-dropdown--menu">
    <Menu>
      <Menu.Item className="avatar-dropdown--menuItem">
        <a className="btn-link-font link" href={PageConstant.DASHBOARD_PROFILE}>
          Basic Info
        </a>
      </Menu.Item>
      <Menu.Item className="avatar-dropdown--menuItem">
        <a className="btn-link-font link" href={PageConstant.ACCOUNT}>
          Settings
        </a>
      </Menu.Item>
      <Menu.Item className="avatar-dropdown--menuItem">
        <a
          className="btn-link-font link"
          onClick={onLogout}
          target="_blank"
          rel="noopener noreferrer"
        >
          Log out
        </a>
      </Menu.Item>
    </Menu>
  </div>
);

const DropIcon = ({ onClick }) => (
  <span
    onClick={onClick}
  >
    <svg
      width="8"
      height="5"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.71054 1.71L3.30054 4.3C3.69054 4.69 4.32054 4.69 4.71054 4.3L7.30054 1.71C7.93054 1.08 7.48054 0 6.59054 0H1.41054C0.52054 0 0.0805397 1.08 0.71054 1.71Z"
        fill="#666666"
      />
    </svg>
  </span>
);

const MenuIcon = ({ onToggle }) => (
  <span className="avatar-menu--icon"
    onClick={onToggle}
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_1553_3396)">
        <path
          d="M4 17.625C3.78333 17.625 3.60433 17.5543 3.463 17.413C3.321 17.271 3.25 17.0917 3.25 16.875C3.25 16.675 3.321 16.5 3.463 16.35C3.60433 16.2 3.78333 16.125 4 16.125H20C20.2167 16.125 20.396 16.2 20.538 16.35C20.6793 16.5 20.75 16.675 20.75 16.875C20.75 17.0917 20.6793 17.271 20.538 17.413C20.396 17.5543 20.2167 17.625 20 17.625H4ZM4 12.75C3.78333 12.75 3.60433 12.679 3.463 12.537C3.321 12.3957 3.25 12.2167 3.25 12C3.25 11.7833 3.321 11.604 3.463 11.462C3.60433 11.3207 3.78333 11.25 4 11.25H20C20.2167 11.25 20.396 11.3207 20.538 11.462C20.6793 11.604 20.75 11.7833 20.75 12C20.75 12.2167 20.6793 12.3957 20.538 12.537C20.396 12.679 20.2167 12.75 20 12.75H4ZM4 7.875C3.78333 7.875 3.60433 7.8 3.463 7.65C3.321 7.5 3.25 7.325 3.25 7.125C3.25 6.90833 3.321 6.72933 3.463 6.588C3.60433 6.446 3.78333 6.375 4 6.375H20C20.2167 6.375 20.396 6.446 20.538 6.588C20.6793 6.72933 20.75 6.90833 20.75 7.125C20.75 7.325 20.6793 7.5 20.538 7.65C20.396 7.8 20.2167 7.875 20 7.875H4Z"
          fill="#666666"
        />
      </g>
    </svg>
  </span>
);

const AvatarDropDown = ({ username, onLogout, toggleMobileDrawer }) => {
  const [dropdownActive, setDropDownActive] = useState(false);

  const wrapperRef = useRef(null);
  const onOutSideClick = () => setDropDownActive(false);
  useOutsideAlerter(wrapperRef, onOutSideClick);

  const isMobile = useIsMobile();

  return (
    <div 
      className="avatar-dropdown--root" 
      ref={wrapperRef}
    > 
      <span
        ref={wrapperRef}
        className="user-profile"
        onClick={() => setDropDownActive(!dropdownActive)}
      >
        <span className="user-name">{username}</span>
        {isMobile ? <MenuIcon onToggle={toggleMobileDrawer} /> : <DropIcon onClick={() => setDropDownActive(!dropdownActive)} />}
      </span>
      {dropdownActive && <DropDownMenu onLogout={onLogout} />}
    </div>
  );
};


const mapStateToProps = (state) => {
  return Object.assign({}, { ...state.drawer });
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    toggleMobileDrawer: () => dispatch(DrawerActions.toggleMobileDrawer())
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(AvatarDropDown) ;
